import clubsModule from "./type";
import eventsModule from "../../../events/module/store/type";
import discoverModule from "../../../discover/module/store/type";

const mutations = {
    [clubsModule.mutations.setClub] (state, payload) {
        state.source.club = {...state.source.club, ...payload}
    },
    [eventsModule.mutations.setTransitionEnabled] (state, payload) {
        state.clubTransitionEnabled = payload
    },
    [clubsModule.mutations.setType] (state, type) {
        state.type = type
        localStorage.setItem('clubs-type', type)
    },
    [clubsModule.mutations.resetPagination](state) {
        state.page = 0
    },
    [clubsModule.mutations.setLoading](state, value) {
        state.clubDates.loading = value
    },
    [clubsModule.mutations.clubs.setPageNum](state, value) {
        state.page = value
    },
    [clubsModule.mutations.clubs.setPageMembersNum](state, value) {
        state.members_page = value
    },
    [clubsModule.mutations.clubs.set](state, clubs) {
        state.clubDates = clubs
    },
    [clubsModule.mutations.filter.set](state, { key, value }) {
        Vue.set(state.clubs_filter, key, value)
    },
    [clubsModule.mutations.clubs.update](state, { clubId, clubData }) {
        /* Discover */
        if (state.clubDates.discover && state.clubDates.discover.length > 0) {
            state.clubDates.discover.forEach((club, index) => {
                if (club.id === clubId) {
                    Vue.set(
                        state.clubDates.discover,
                        index,
                        {...club, ...clubData}
                    )
                }
            })
        }

        /* Invited */
        if (state.clubDates.invited && state.clubDates.invited.length > 0) {
            state.clubDates.invited.forEach((club, index) => {
                if (club.id === clubId) {
                    Vue.set(
                        state.clubDates.invited,
                        index,
                        {...club, ...clubData}
                    )
                }
            })
        }

        /* Accepted */
        if (state.clubDates.accepted && state.clubDates.accepted.length > 0) {
            state.clubDates.accepted.forEach((club, index) => {
                if (club.id === clubId) {
                    Vue.set(
                        state.clubDates.accepted,
                        index,
                        {...club, ...clubData}
                    )
                }
            })
        }

        /* My clubs */
        if (state.clubDates.my_clubs && state.clubDates.my_clubs.length > 0) {
            state.clubDates.my_clubs.forEach((club, index) => {
                if (club.id === clubId) {
                    Vue.set(
                        state.clubDates.my_clubs,
                        index,
                        {...club, ...clubData}
                    )
                }
            })
        }
    },
    [clubsModule.mutations.clubs.remove](state, clubId) {
        /* Discover */
        if (state.clubDates.discover && state.clubDates.discover.length > 0) {
            state.clubDates.discover.forEach((club, index) => {
                if (club.id === clubId) {
                    Vue.delete(state.clubDates.discover, index)
                }
            })
        }

        /* Invited */
        if (state.clubDates.invited && state.clubDates.invited.length > 0) {
            state.clubDates.invited.forEach((club, index) => {
                if (club.id === clubId) {
                    Vue.delete(state.clubDates.invited, index)
                }
            })
        }

        /* Accepted */
        if (state.clubDates.accepted && state.clubDates.accepted.length > 0) {
            state.clubDates.accepted.forEach((club, index) => {
                if (club.id === clubId) {
                    Vue.delete(state.clubDates.accepted, index)
                }
            })
        }

        /* My clubs */
        if (state.clubDates.my_clubs && state.clubDates.my_clubs.length > 0) {
            state.clubDates.my_clubs.forEach((club, index) => {
                if (club.id === clubId) {
                    Vue.delete(state.clubDates.my_clubs, index)
                }
            })
        }
    },
    [clubsModule.mutations.clubs.add](state, data) {
        if (data.invited && data.invited.length) {
            state.clubDates.invited.push(...data.invited)
        }

        if (data.accepted && data.accepted.length) {
            state.clubDates.accepted.push(...data.accepted)
        }

        if (data.discover && data.discover.length) {
            state.clubDates.discover.push(...data.discover)
            state.clubDates.discover_has_more = data.discover.length > window.LOAD_CLUBS_DATES_PER_PAGE ? true : false
        }

        if (data.my_clubs && data.my_clubs.length) {
            state.clubDates.my_clubs.push(...data.my_clubs)
        }
    },
    [clubsModule.mutations.membership.add](state, clubId) {
        Vue.set(state.membershipClubsRequests, clubId, true)
    },
    [clubsModule.mutations.membership.remove](state, clubId) {
        Vue.delete(state.membershipClubsRequests, clubId)
    },
    [clubsModule.mutations.membership.addMy](state, clubId) {
        Vue.set(state.myMemberships, clubId, true)
    },
    [clubsModule.mutations.membership.removeMy](state, clubId) {
        Vue.delete(state.myMemberships, clubId)
    },
    [clubsModule.mutations.setLikes](state, club) {
        let clubId = club.id

        /* Discover */
        if (state.clubDates.discover && state.clubDates.discover.length > 0) {
            state.clubDates.discover.forEach((club, index) => {
                if (club.id === clubId) {
                    if (club.isLiked) {
                        club.likes++
                    } else {
                        club.likes--
                    }

                    Vue.set(state.clubDates.discover, index, club);
                }
            })
        }

        /* Invited */
        if (state.clubDates.invited && state.clubDates.invited.length > 0) {
            state.clubDates.invited.forEach((club, index) => {
                if (club.id === clubId) {
                    if (club.isLiked) {
                        club.likes++
                    } else {
                        club.likes--
                    }

                    Vue.set(state.clubDates.invited, index, club);
                }
            })
        }

        /* Accepted */
        if (state.clubDates.accepted && state.clubDates.accepted.length > 0) {
            state.clubDates.accepted.forEach((club, index) => {
                if (club.id === clubId) {
                    if (club.isLiked) {
                        club.likes++
                    } else {
                        club.likes--
                    }

                    Vue.set(state.clubDates.accepted, index, club);
                }
            })
        }

        /* My clubs */
        if (state.clubDates.my_clubs && state.clubDates.my_clubs.length > 0) {
            state.clubDates.my_clubs.forEach((club, index) => {
                if (club.id === clubId) {
                    if (club.isLiked) {
                        club.likes++
                    } else {
                        club.likes--
                    }

                    Vue.set(state.clubDates.my_clubs, index, club);
                }
            })
        }

        if (this.state.clubsInfo[club.id]) {
            this.state.clubsInfo[club.id] = club;
        }
    }
}

export default mutations
